import { render, staticRenderFns } from "./EditorCustom.vue?vue&type=template&id=089ba454&"
import script from "./EditorCustom.vue?vue&type=script&lang=js&"
export * from "./EditorCustom.vue?vue&type=script&lang=js&"
import style0 from "./EditorCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports